import {OperatorData} from "../models/OperatorData";
import {HistoryMessage} from "../../../../types/history";


//#region Action Interfaces

export interface AppendLiveChatHistoryMessageAction
{
    type: 'APPEND_LIVE_CHAT_HISTORY_MESSAGE';
    historyMessage: HistoryMessage;
}

interface OperatorTypingAction
{
    type: 'OPERATOR_TYPING';
    payload: {
        stateLocation: string;
        isTyping: boolean;
    };
}

interface RemoveQueueBannersAction
{
    type: 'REMOVE_QUEUE_BANNERS';
}

interface SaveOperatorDataAction {
    type: "SAVE_OPERATOR_DATA";
    payload: {
        operatorData: OperatorData;
        stateLocation: string;
    };
}

interface SetLastSeenIndexAction
{
    type: 'SET_LAST_SEEN_INDEX';
    payload: {
        stateLocation: string;
        lastSeenIndex: number;
    };
}

interface SetQueueTextAction
{
    type: 'SET_QUEUE_TEXT';
    payload: {
        stateLocation: string;
        text: string | null;
    };
}

interface SetUserTypingStateAction
{
    type: 'SET_USER_TYPING_STATE';
    payload: {
        stateLocation: string;
        userTyping: "FINISHED" | "PAUSED" | "STARTED";
    };
}

interface UpdateChatSessionStateAction
{
    type: "UPDATE_CHAT_SESSION_STATE";
    payload: {
        stateLocation: string;
        sessionState: string;
    };
}

//#endregion



//#region ActionTypes

export type LiveChatActionTypes = AppendLiveChatHistoryMessageAction|
    OperatorTypingAction |
    RemoveQueueBannersAction |
    SaveOperatorDataAction |
    SetLastSeenIndexAction |
    SetQueueTextAction |
    SetUserTypingStateAction |
    UpdateChatSessionStateAction;

//#endregion



//#region Action Constructors

export function appendLiveChatHistoryMessage(historyMessage: HistoryMessage): LiveChatActionTypes
{
    return {
        type: "APPEND_LIVE_CHAT_HISTORY_MESSAGE",
        historyMessage,
    };
}

export function operatorTyping(stateLocation: string, isTyping: boolean): LiveChatActionTypes
{
    return {
        type: "OPERATOR_TYPING",
        payload: {
            stateLocation,
            isTyping,
        },
    };
}

export function removeQueueBanners(): LiveChatActionTypes
{
    return {
        type: "REMOVE_QUEUE_BANNERS",
    };
}

export function saveOperatorData(operatorData: OperatorData, stateLocation: string): LiveChatActionTypes
{
    return {
        type: 'SAVE_OPERATOR_DATA',
        payload: {
            operatorData,
            stateLocation,
        },
    };
}

export function setLastSeenIndex(stateLocation: string, lastSeenIndex: number): LiveChatActionTypes
{
    return {
        type: "SET_LAST_SEEN_INDEX",
        payload: {
            stateLocation,
            lastSeenIndex,
        },
    };
}

export function setQueueText(stateLocation: string, text: string | null): LiveChatActionTypes
{
    return {
        type: "SET_QUEUE_TEXT",
        payload: {
            stateLocation,
            text,
        },
    };
}

export function setUserTypingState(stateLocation: string, userTyping: "FINISHED" | "PAUSED" | "STARTED"): LiveChatActionTypes
{
    return {
        type: "SET_USER_TYPING_STATE",
        payload: {
            stateLocation,
            userTyping,
        },
    };
}

export function updateChatSessionState(stateLocation: string, sessionState: string): LiveChatActionTypes
{
    return {
        type: 'UPDATE_CHAT_SESSION_STATE',
        payload: {
            stateLocation,
            sessionState,
        },
    };
}

//#endregion



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/actions/actions.ts